import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { appStorage } from '@sternum/web/services/appStorage';

import { ThemeMode } from '../main/ThemeMode.context';

export interface MainThemeState {
  mode: ThemeMode;
}

const initialState: MainThemeState = {
  mode: (await appStorage.getThemeMode()) || 'Light',
};

export const mainThemeSlice = createSlice({
  name: 'mainThemeMode',
  initialState,
  reducers: {
    setMainThemeMode(state, action: PayloadAction<ThemeMode>) {
      state.mode = action.payload;
    },
    toggleMainThemeModeAction(state) {
      state.mode = state.mode === 'Dark' ? 'Light' : 'Dark';
    },
  },
});

export const { setMainThemeMode, toggleMainThemeModeAction } = mainThemeSlice.actions;
